import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import CategoryTabs from '@/components/feature/CategoryTabs';
import ScrollToTop from '@/components/feature/ScrollToTop';
import PageMeta from '@/components/feature/PageMeta';
import { OrganizationSchema, WebSiteSchema, WebPageSchema } from '@/components/feature/SchemaOrg';

export default function Home() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 4);
  const latestArticles = [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  const getCategoryName = (slug: string) => categories.find((c) => c.slug === slug)?.name || slug;

  return (
    <>
      <ScrollToTop />
      <PageMeta
        title="黑料bu｜最新黑料资讯聚合平台 - 明星网红大V黑料一手掌握"
        description="黑料bu是专注收录网络热点黑料的资讯聚合平台，第一时间汇聚明星、网红、大V的最新黑料动态，内容真实可查，更新及时，助你掌握第一手黑料bu信息，不错过任何热点瓜。"
        keywords="黑料bu,黑料bu最新,黑料bu网红,黑料bu明星,黑料bu吃瓜,黑料bu热点"
        canonicalUrl="https://heiliao.bu"
        ogImage="https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20aggregation%20platform%20homepage%2C%20modern%20dark%20design%20with%20warm%20orange%20accents%2C%20breaking%20news%20concept%2C%20cinematic%20noir%20style&width=1200&height=630&seq=og-home&orientation=landscape"
      />
      <OrganizationSchema
        name="黑料bu"
        url="https://heiliao.bu"
        description="黑料bu是专注收录网络热点黑料的资讯聚合平台，第一时间汇聚明星、网红、大V的最新黑料动态。"
      />
      <WebSiteSchema
        name="黑料bu"
        url="https://heiliao.bu"
        description="黑料bu是专注收录网络热点黑料的资讯聚合平台，第一时间汇聚明星、网红、大V的最新黑料动态。"
      />
      <WebPageSchema
        name="黑料bu - 首页"
        url="https://heiliao.bu"
        description="黑料bu首页，最新黑料资讯聚合，明星网红大V黑料一手掌握。"
        dateModified="2026-08-07"
      />

      <Navbar />

      <main>
        <section className="relative w-full">
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/50 to-background-50 z-10"></div>
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20dark%20gradient%20background%20with%20warm%20orange%20and%20amber%20light%20streaks%2C%20minimalist%20modern%20design%2C%20cinematic%20atmosphere%2C%20dramatic%20lighting%20with%20soft%20glow%20effects%2C%20editorial%20news%20media%20aesthetic%2C%20no%20text%20no%20people%2C%20clean%20abstract%20composition&width=1800&height=700&seq=hero-bg&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="relative z-20 w-full flex flex-col items-center justify-center text-center px-4 py-24 md:py-32">
            <span className="inline-block bg-accent-500/90 text-background-50 text-xs font-semibold px-3 py-1 rounded-full mb-4 tracking-wide">
              热点速递 · HOT
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 max-w-4xl leading-tight mb-6">
              最新<strong className="text-accent-500">黑料</strong>资讯，一手掌握
            </h1>
            <p className="text-base md:text-lg text-background-300 max-w-2xl leading-relaxed mb-8">
              黑料bu专注收录明星、网红、大V最新黑料动态，内容真实可查、更新及时，不错过任何一个热点瓜。
            </p>
            <div className="flex items-center gap-3 flex-wrap justify-center">
              <Link
                to="/category/zuixin"
                className="bg-accent-500 hover:bg-accent-600 text-background-50 px-6 py-3 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap"
              >
                最新爆料
                <i className="ri-arrow-right-line ml-1"></i>
              </Link>
              <Link
                to="/category/chiigua"
                className="bg-background-50/20 hover:bg-background-50/30 text-background-50 border border-background-50/30 px-6 py-3 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap"
              >
                热点吃瓜
              </Link>
            </div>

            <div className="flex items-center gap-8 mt-12 flex-wrap justify-center">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">{articles.length}+</div>
                <div className="text-xs text-background-400 mt-1">黑料文章</div>
              </div>
              <div className="w-px h-12 bg-background-50/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">{categories.length}</div>
                <div className="text-xs text-background-400 mt-1">资讯分类</div>
              </div>
              <div className="w-px h-12 bg-background-50/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">10万+</div>
                <div className="text-xs text-background-400 mt-1">日活跃用户</div>
              </div>
            </div>
          </div>
        </section>

        <CategoryTabs />

        <section className="w-full px-4 md:px-8 py-10 md:py-14">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
                <i className="ri-fire-line text-accent-500 mr-2"></i>
                热门黑料
              </h2>
              <p className="text-sm text-foreground-500 mt-1">当前最受关注的黑料动态</p>
            </div>
            <Link to="/category/chiigua" className="text-sm text-accent-500 hover:text-accent-600 font-medium whitespace-nowrap flex items-center gap-1">
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {hotArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </section>

        <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-2">
            最新爆料
          </h2>
          <p className="text-sm text-foreground-500 mb-6">24小时滚动更新的黑料资讯</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {latestArticles.slice(0, 6).map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </section>

        <section className="w-full px-4 md:px-8 py-10 md:py-14">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-2">
            资讯分类
          </h2>
          <p className="text-sm text-foreground-500 mb-6">按类别浏览你最关注的黑料</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {categories.map((cat, idx) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group bg-background-50 border border-background-200 rounded-lg p-5 hover:border-accent-300 transition-all duration-200"
              >
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-3 group-hover:bg-accent-200 transition-colors">
                  <i className={`text-accent-600 text-lg ${
                    ['ri-star-line', 'ri-live-line', 'ri-user-star-line', 'ri-flashlight-line', 'ri-fire-line'][idx]
                  }`}></i>
                </div>
                <h3 className="text-base font-semibold font-heading text-foreground-950 mb-1">{cat.name}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{cat.description}</p>
                <div className="flex items-center gap-1 text-accent-500 text-xs mt-3 font-medium">
                  <span>浏览分类</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            ))}
          </div>
        </section>

        <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-3">
              不错过任何一个瓜
            </h2>
            <p className="text-sm text-foreground-600 mb-6 leading-relaxed">
              黑料bu每日更新最新黑料资讯，覆盖明星、网红、大V等全品类，让你永远站在吃瓜第一线。
            </p>
            <Link
              to="/category/zuixin"
              className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 px-8 py-3 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap"
            >
              立即浏览最新黑料 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}